/**
 * Level 1: 对象检测 — 是否有狗 (spec 2.2, plan 3.1)
 * MediaPipe Object Detector, category === 'dog' && score > 0.7
 */

import { ObjectDetector, FilesetResolver } from '@mediapipe/tasks-vision';

const WASM =
  'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm';
const MODEL =
  'https://storage.googleapis.com/mediapipe-tasks/object_detector/efficientdet_lite0_uint8.tflite';

let detector: ObjectDetector | null = null;

export interface DogDetection {
  hasDog: boolean;
  score: number;
  bbox: { x: number; y: number; w: number; h: number };
  /** 无狗时：若画面里主要是人，为 true，用于友好提示 */
  detectedPerson?: boolean;
}

export async function initObjectDetector(): Promise<void> {
  if (detector) return;
  const vision = await FilesetResolver.forVisionTasks(WASM);
  detector = await ObjectDetector.createFromOptions(vision, {
    baseOptions: { modelAssetPath: MODEL },
    scoreThreshold: 0.5,
    runningMode: 'IMAGE',
  });
}

export function detectDog(imageSource: HTMLVideoElement | HTMLCanvasElement): DogDetection | null {
  if (!detector) return null;
  const results = detector.detect(imageSource);
  let detectedPerson = false;
  for (const d of results.detections) {
    const cat = d.categories?.[0];
    const name = cat?.categoryName ?? '';
    const score = cat?.score ?? 0;
    if (name === 'dog' && score > 0.5) {
      const b = d.boundingBox;
      return {
        hasDog: true,
        score,
        bbox: { x: b?.originX ?? 0, y: b?.originY ?? 0, w: b?.width ?? 0, h: b?.height ?? 0 },
      };
    }
    if ((name === 'person' || name === 'human') && score > 0.5) detectedPerson = true;
  }
  return {
    hasDog: false,
    score: 0,
    bbox: { x: 0, y: 0, w: 0, h: 0 },
    detectedPerson,
  };
}
